import React from 'react';
import { DemeterCommodity } from '../../../../Generated/Raven-Demeter';
import useLanguage from '../../../Services/Language/useLanguageHook';
import styles from './NewsComponents.module.scss';

interface ICommoditySidebarProps {
    commodities: DemeterCommodity[];
    selectedCommodity: DemeterCommodity | null;
    onSelect: (commodity: DemeterCommodity | null) => void;
}

const CommoditySidebar: React.FC<ICommoditySidebarProps> = (props) => {
    const [translations] = useLanguage();

    return (
        <div className={styles.sidebar}>
            <div className={styles.sidebar_title}>{translations.words.commodity}</div>
            <button
                type="button"
                className={`${styles.sidebar_item} ${props.selectedCommodity === null ? styles.sidebar_item_active : ''}`}
                onClick={() => props.onSelect(null)}
            >
                {translations.words.all}
            </button>
            {props.commodities.map((commodity) => (
                <button
                    key={commodity}
                    type="button"
                    className={`${styles.sidebar_item} ${props.selectedCommodity === commodity ? styles.sidebar_item_active : ''}`}
                    onClick={() => props.onSelect(commodity)}
                >
                    {translations.commodity[commodity as DemeterCommodity] || commodity}
                </button>
            ))}
            <div className={styles.sidebar_footnote}>{translations.aiNewsRating.footnote}</div>
        </div>
    );
};

export default CommoditySidebar;
